/* eslint-disable */
import React, { useState, useContext, useEffect } from "react";
import {
  Button,
  Form,
  OverlayTrigger,
  Tooltip,
  Spinner,
  Modal,
  FormControl,
  FormSelect,
} from "react-bootstrap";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import { PURCHASE_LIST_URL } from "../../Shared/constant";
import EmptySpaceFieldValid from "../../Common/EmptySpaceFieldValid";
import CheckValid from "../../Common/CheckValid";
import { useSelector, useDispatch } from "react-redux";
import { WebSocketContext } from "../../../App";
import wsSend_request from "../../../Api/ws/ws_request";
import Select from "react-select";
import {
  StartMainCommonLoader,
  StartCommonLoader,
  SearchPincodeList,
  ErrorMessageFromRedux,
  ErrorFramesMessageFromRedux,
  GetFrameList,
} from "../../../redux/actions/adminActions";
import {
  parsePhoneNumber,
  getRegionCodeForCountryCode,
} from "awesome-phonenumber";
import UploadFileAPI from "../../../Api/UploadFileAPI";
import CommonToggle from "../../Common/CommonToggle";
import CommonScrollBar from "../../Common/CommonScrollBar";
import { customFilterOption } from "../../Common/customFilterOption";
import DatePicker from "react-datepicker";
import PromoEligibleAPI from "../../../Api/PromoEligibleAPI";
import { toast } from "react-toastify";
import WarrantyCancellationAPI from "../../../Api/WarrantyCancellationAPI";
import BrowserUniqueTabID from "../../Common/BrowserUniqueTabID";

const EditPurchase = (props) => {
  const Dispatch = useDispatch();
  const Navigate = useNavigate();
  const LocationRoute = useLocation()?.pathname?.split("/")[1];
  const { websocket } = useContext(WebSocketContext);
  const { roomId } = useParams();
  const {
    accessToken,
    ClearFormSet,
    productlistall,
    AllDealerFranchiseTypeListAll,
    commonMainLoader,
    device_id,
    PurchaseList,
    commonLoader,
    ErrorMessageFromReddux,
    ErrorFramesMessageFromReddux,
    searchPincodeList,
    FrameList,
    AllHelpDeskSubcategoryList,
  } = useSelector((state) => state.adminReducers);

  const CurrentData_ = PurchaseList?.list?.filter(
    (elm) => elm?.id === roomId,
  )[0];
  const optionsProduct = productlistall
    ?.filter((elm) => elm?.is_bike === true)
    ?.map((item, index) => ({
      key: item.id,
      value: item?.id,
      label: item?.product_name,
    }));
  const FranchiseListOption = AllDealerFranchiseTypeListAll?.list
    ?.filter((elm) => elm?.parent_id === null)
    ?.map((item, index) => ({
      ...item,
      key: item.id,
      value: item?.id,
      label: item?.customer_name,
    }));
  const [ApplicationState, setApplicationState] = useState({
    CustomerName: "",
    Email: "",
    Mobile: "",
    UseCase: "",
    AgeGroup: "",
    PINCode: "",
    ProductValue: "",
    FrameNumber: "",
    ProductName: "",
    DealerInfo: "",
    FrameNumberImage: "",
    FrameAvailable: false,
    PurchaseDate: "",
  });
  const [Attachment, setAttachment] = useState({
    filename: "",
    fileID: "",
  });
  const [VoucherFlag, setVoucherFlag] = useState({
    Yes: false,
    No: true,
  });
  const [LoaderFile, setLoaderFile] = useState(false);
  const [UploadFrameNumberLoader, setUploadFrameNumberLoader] = useState(false);
  const [FrameImageDisplay, setFrameImageDisplay] = useState("");
  const optionsUseCase = [
    { key: 1, value: "Health & Fitness", label: "Health & Fitness" },
    { key: 2, value: "Daily Use - Health", label: "Daily Use - Health" },
    {
      key: 3,
      value: "Daily Use - Cost Saving",
      label: "Daily Use - Cost Saving",
    },
    { key: 4, value: "Kids", label: "Kids" },
  ];
  const optionsAgeGroups = [
    { key: 1, value: "Below 18", label: "Below 18" },
    { key: 2, value: "18-35", label: "18-35" },
    { key: 3, value: "35 & Above", label: "35 & Above" },
  ];

  // error state
  const [errorCustomerName, seterrorCustomerName] = useState("");
  const [errorPurchaseDate, seterrorPurchaseDate] = useState("");
  const [errorMobile, seterrorMobile] = useState("");
  const [errorEmail, seterrorEmail] = useState("");
  const [errorAgeGroup, seterrorAgeGroup] = useState("");
  const [errorPINCode, seterrorPINCode] = useState("");
  const [errorProductName, seterrorProductName] = useState("");
  const [errorDealerInfo, seterrorDealerInfo] = useState("");
  const [errorUseCase, seterrorUseCase] = useState("");
  const [errorFrameNumber, seterrorFrameNumber] = useState("");
  const [errorProductValue, seterrorProductValue] = useState("");
  const [errorUploadFile, seterrorUploadFile] = useState("");
  const [currentFrameNumber, setCurrentFrameNumber] = useState("");
  const [pendingWarrantyUpdate, setPendingWarrantyUpdate] = useState(false);

  // error state
  const EmailRegex =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/; // eslint-disable-line
  const exceptThisCostSymbols = ["e", "E", "+", "-", "."];

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      fontSize: "13px", // Adjust the font size as per your requirement
    }),
  };

  // get all product list
  useEffect(() => {
    let param = {
      transmit: "broadcast",
      url: "product_list",
      request: {
        status: true,
        limit: 5000,
        page_no: 1,
        search: "",
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
  }, [websocket]);

  // get all franchise list
  useEffect(() => {
    let param = {
      transmit: "broadcast",
      url: "franchise_list",
      request: {
        status: true,
        limit: 5000,
        page_no: 1,
        search: "",
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
  }, [websocket]);
  useEffect(() => {
    let param = {
      transmit: "broadcast",
      url: "help_desk_subcategory_list",
      request: {
        status: true,
        limit: 5000,
        page_no: 1,
        search: "",
        order_by: "-updated_at",
        category_id: "073ef0f0-2f3e-4174-82cc-b96f979d417d",
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
  }, [websocket]);
  useEffect(() => {
    if (LocationRoute === "edit-purchase") {
      const CurrentPincode = PurchaseList?.pin_code.filter(
        (elm) => elm?.id === CurrentData_?.pin_code_id,
      )[0]?.pin_code;
      const CurrentUseCase = optionsUseCase?.filter(
        (elm) => elm?.label === CurrentData_?.use_case,
      )[0];
      const CurrentAgeGroup = optionsAgeGroups?.filter(
        (elm) => elm?.label === CurrentData_?.age_group,
      )[0];
      const CurrentProduct =
        Object?.keys(FrameList)?.length > 0
          ? optionsProduct?.filter(
              (elm) => elm?.value === FrameList?.product?.id,
            )[0]
          : optionsProduct?.filter(
              (elm) => elm?.value === CurrentData_?.product_id,
            )[0];
      const CurrentDealerInfo =
        Object?.keys(FrameList)?.length > 0
          ? FranchiseListOption?.filter(
              (elm) => elm?.value === FrameList?.franchise?.id,
            )[0]
          : FranchiseListOption?.filter(
              (elm) => elm?.value === CurrentData_?.franchise_id,
            )[0];
      setTimeout(() => {
        if (CurrentPincode?.length === 6) {
          let param = {
            transmit: "broadcast",
            url: "pin_code_search",
            request: {
              pin_code: CurrentPincode,
            },
            DeviceId: device_id,
          };
          wsSend_request(websocket, param);
        } else {
          Dispatch(StartCommonLoader(false));
        }
        setApplicationState({
          ...ApplicationState,
          CustomerName: CurrentData_?.customer_name,
          Email: CurrentData_?.email,
          Mobile: CurrentData_?.mobile,
          UseCase: CurrentUseCase,
          AgeGroup: CurrentAgeGroup,
          PINCode: CurrentPincode,
          FrameNumber: CurrentData_?.frame_number,
          ProductName: CurrentProduct,
          DealerInfo: CurrentDealerInfo,
          ProductValue: CurrentData_?.product_value,
          FrameAvailable: CurrentData_?.frame_available,
          FrameNumberImage: CurrentData_?.frame_number_image,
          PurchaseDate: CurrentData_?.purchase_date
            ? new Date(CurrentData_.purchase_date)
            : null,
        });
        setCurrentFrameNumber(CurrentData_?.frame_number);
        setAttachment({
          ...Attachment,
          filename:
            CurrentData_?.invoice_image_name === null
              ? ""
              : CurrentData_?.invoice_image_name,
          fileID:
            CurrentData_?.invoice_image === null
              ? ""
              : CurrentData_?.invoice_image,
        });
        setVoucherFlag({
          ...VoucherFlag,
          Yes: CurrentData_?.is_voucher === true ? true : false,
          No: CurrentData_?.is_voucher === true ? false : true,
        });
        setFrameImageDisplay(
          CurrentData_?.frame_number_image_name === null
            ? ""
            : {
                name: CurrentData_?.frame_number_image_name,
              },
        );
      }, 500);
    }
  }, [CurrentData_]);

  useEffect(() => {
    if (Object?.keys(FrameList)?.length > 0) {
      let CurrentProductVar = optionsProduct?.filter(
        (elm) => elm?.value === FrameList?.product?.id,
      )[0];
      const CurrentDealerInfoVar = FranchiseListOption?.filter(
        (elm) =>
          elm?.value === FrameList?.franchise?.id ||
          elm?.franchise_code === FrameList?.customer?.franchise_code,
      )[0];
      setApplicationState({
        ...ApplicationState,
        ProductName: CurrentProductVar,
        DealerInfo: CurrentDealerInfoVar,
      });
    } else {
      let CurrentProductVar = optionsProduct?.filter(
        (elm) => elm?.value === CurrentData_?.product_id,
      )[0];
      const CurrentDealerInfoVar = FranchiseListOption?.filter(
        (elm) => elm?.value === CurrentData_?.franchise_id,
      )[0];
      setApplicationState({
        ...ApplicationState,
        ProductName: CurrentProductVar,
        DealerInfo: CurrentDealerInfoVar,
      });
    }
  }, [FrameList, CurrentData_]);

  // search pincode
  const onEnterPincodeSearch = (e) => {
    const code = e.which || e.keyCode;
    if (code === 13) {
      SearchPincode();
    }
  };

  // search pincode
  const SearchPincode = () => {
    if (ApplicationState?.PINCode?.length === 6) {
      Dispatch(StartCommonLoader(true));
      let param = {
        transmit: "single",
        url: "pin_code_search",
        request: {
          pin_code: ApplicationState?.PINCode,
        },
        DeviceId: device_id,
      };
      wsSend_request(websocket, param);
    } else {
      Dispatch(StartCommonLoader(false));
    }
  };

  const SearchInvoiceFunction = (e) => {
    setApplicationState({
      ...ApplicationState,
      FrameNumber: e.target.value,
    });
    if (e.target.value === "") {
      Dispatch(GetFrameList({}));
      Dispatch(
        ErrorFramesMessageFromRedux({
          API: "",
          Error: "",
        }),
      );
    }
  };

  // pin code error get from redux
  useEffect(() => {
    if (
      ErrorMessageFromReddux?.API === "pin_code_search" &&
      ErrorMessageFromReddux?.Error !== ""
    ) {
      seterrorPINCode(ErrorMessageFromReddux?.Error);
    }
  }, [ErrorMessageFromReddux]);

  useEffect(() => {
    if (ErrorFramesMessageFromReddux?.API === "get_frame_number") {
      if (
        ErrorFramesMessageFromReddux?.message ==
        "We couldn't find this Frame number, kindly verify once or contact our regional manager to raise an issue."
      ) {
        setApplicationState((prev) => ({
          ...prev,
          FrameAvailable: false,
        }));
      }
      if (ErrorFramesMessageFromReddux?.Error !== "") {
        if (
          !ApplicationState.FrameNumber ||
          ApplicationState.FrameNumber === currentFrameNumber
        ) {
          return;
        }

        seterrorFrameNumber(ErrorFramesMessageFromReddux?.Error);
      }
    }
  }, [ErrorFramesMessageFromReddux, FrameList]);

  const PinCOdeSearchFunction = (e) => {
    setApplicationState({ ...ApplicationState, PINCode: e.target.value });
    if (e.target.value.length === 6) {
      Dispatch(StartCommonLoader(true));
      let param = {
        transmit: "broadcast",
        url: "pin_code_search",
        request: {
          pin_code: e.target.value,
        },
        DeviceId: device_id,
      };
      wsSend_request(websocket, param);
    }
    if (e.target.value === "") {
      Dispatch(SearchPincodeList({}));
      Dispatch(
        ErrorMessageFromRedux({
          API: "",
          Error: "",
        }),
      );
    } else {
      Dispatch(StartCommonLoader(false));
    }
  };

  // select user case
  const SelectUserCase = (value) => {
    if (value !== null) {
      setApplicationState({
        ...ApplicationState,
        UseCase: value,
      });
      seterrorUseCase("");
    } else {
      setApplicationState({
        ...ApplicationState,
        UseCase: "",
      });
      seterrorUseCase("Please select User case");
    }
  };

  // select age groups
  const SelectAgeGroups = (value) => {
    if (value !== null) {
      setApplicationState({
        ...ApplicationState,
        AgeGroup: value,
      });
      seterrorAgeGroup("");
    } else {
      setApplicationState({
        ...ApplicationState,
        AgeGroup: "",
      });
      seterrorAgeGroup("Please select age groups");
    }
  };

  // search invoice id
  const onEnterInvoiceSearch = (e) => {
    const code = e.which || e.keyCode;
    if (code === 13) {
      SearchOrderList();
    }
  };

  // search order api
  const SearchOrderList = () => {
    if (ApplicationState?.FrameNumber === currentFrameNumber) return;
    if (ApplicationState?.FrameNumber?.trim() !== "") {
      Dispatch(
        StartMainCommonLoader({
          url: "get_frame_number",
          loader: true,
        }),
      );
      let param = {
        transmit: "broadcast",
        url: "get_frame_number",
        request: {
          frame_number: ApplicationState?.FrameNumber?.trim(),
        },
        DeviceId: device_id,
      };
      wsSend_request(websocket, param);
    } else {
      Dispatch(
        StartMainCommonLoader({
          url: "get_frame_number",
          loader: false,
        }),
      );
    }
  };

  // REMOVE FRAME NUMBER IMAGE
  const RemoveFrameNumberUploadImage = () => {
    setApplicationState({
      ...ApplicationState,
      FrameNumberImage: "",
    });
    setFrameImageDisplay("");
    setUploadFrameNumberLoader(false);
  };

  const UploadFrameNumberImage = async (e) => {
    const files = e.target.files[0];
    if (files) {
      setUploadFrameNumberLoader(true);
      const formData = new FormData();
      formData.append("file", files, files.name);
      const fileresponse = await UploadFileAPI(accessToken, formData);
      if (fileresponse?.status === 200) {
        setApplicationState({
          ...ApplicationState,
          FrameNumberImage: fileresponse?.id,
        });
        setFrameImageDisplay({
          name: files.name,
        });
        setTimeout(() => {
          setUploadFrameNumberLoader(false);
        }, 1000);
        document.getElementById("fileInputnew").value = null;
      } else {
        setApplicationState({
          ...ApplicationState,
          FrameNumberImage: "",
        });
        setUploadFrameNumberLoader(false);
      }
    }
  };

  // upload attachments
  const UploadImage = async (e) => {
    const files = e.target.files[0];
    if (files) {
      setLoaderFile(true);
      const formData = new FormData();
      formData.append("file", files, files.name);
      const fileresponse = await UploadFileAPI(accessToken, formData);
      if (fileresponse?.status === 200) {
        setAttachment({
          ...Attachment,
          filename: fileresponse?.name,
          fileID: fileresponse?.id,
        });
        setTimeout(() => {
          setLoaderFile(false);
        }, 1000);
        document.getElementById("fileInput").value = null;
      } else {
        setLoaderFile(false);
        setAttachment({
          ...Attachment,
          filename: "",
          fileID: "",
        });
      }
    }
  };

  // Product select
  const ProductSelect = (value) => {
    if (value !== null) {
      setApplicationState({
        ...ApplicationState,
        ProductName: value,
      });
      CheckValid(value, { type: "ProductName", error: seterrorProductName });
    } else {
      setApplicationState({
        ...ApplicationState,
        ProductName: "",
      });
      CheckValid(value, { type: "ProductName", error: seterrorProductName });
    }
  };

  // franchise select fucntion
  const FranchiseSelect = (value) => {
    if (value !== null) {
      setApplicationState({
        ...ApplicationState,
        DealerInfo: value,
      });
      CheckValid(value, { type: "DealerInfo", error: seterrorDealerInfo });
    } else {
      setApplicationState({
        ...ApplicationState,
        DealerInfo: "",
      });
      CheckValid(value, { type: "DealerInfo", error: seterrorDealerInfo });
    }
  };

  const PhoneCode = 91;
  const CountryStates = getRegionCodeForCountryCode(PhoneCode);
  const CheckMobileNumber = parsePhoneNumber(
    ApplicationState?.Mobile?.toString(),
    { regionCode: CountryStates },
  );

  useEffect(() => {
    if (!pendingWarrantyUpdate) return;

    if (
      ErrorFramesMessageFromReddux?.API === "get_frame_number" &&
      ErrorFramesMessageFromReddux?.Error !== ""
    ) {
      toast.error(ErrorFramesMessageFromReddux?.Error);
      setPendingWarrantyUpdate(false);
      return;
    }

    if (
      ErrorFramesMessageFromReddux?.API === "get_frame_number" &&
      ErrorFramesMessageFromReddux?.Error === ""
    ) {
      setPendingWarrantyUpdate(false);
      SubmitFunction(true);
    }
  }, [ErrorFramesMessageFromReddux, pendingWarrantyUpdate]);

  const hasFrameError = () => {
    // If frame number is unchanged → no error
    if (ApplicationState.FrameNumber === currentFrameNumber) {
      return false;
    }

    return (
      ErrorFramesMessageFromReddux?.API === "get_frame_number" &&
      ErrorFramesMessageFromReddux?.Error !== ""
    );
  };

  var tabID = BrowserUniqueTabID();

  // create and edit brand
  const SubmitFunction = async (skipFrameSearch = false) => {
    if (!skipFrameSearch) {
      // If same frame → skip search + directly proceed
      if (ApplicationState.FrameNumber === currentFrameNumber) {
        return SubmitFunction(true);
      }

      if (hasFrameError()) {
        toast.error(ErrorFramesMessageFromReddux?.Error);
        return;
      }

      setPendingWarrantyUpdate(true);
      SearchOrderList();
      return;
    }
    if (
      ApplicationState?.CustomerName.trim() !== "" &&
      ApplicationState?.ProductName !== "" &&
      ApplicationState?.ProductValue.trim() !== "" &&
      ApplicationState?.Mobile.trim() !== "" &&
      ApplicationState?.Email.trim() !== "" &&
      ApplicationState?.UseCase !== "" &&
      ApplicationState?.FrameNumber.trim() !== "" &&
      ApplicationState?.AgeGroup !== "" &&
      ApplicationState?.PINCode.trim() !== "" &&
      ApplicationState?.DealerInfo !== "" &&
      Attachment?.fileID !== null &&
      Attachment?.fileID !== ""
    ) {
      if (
        EmailRegex.test(ApplicationState?.Email) === true &&
        CheckMobileNumber?.valid === true &&
        ApplicationState?.PINCode.trim()?.length === 6
      ) {
        const shouldMarkFrameUnavailable =
          ErrorFramesMessageFromReddux?.message ===
          "We couldn't find this Frame number, kindly verify once or contact our regional manager to raise an issue.";
        let param = {
          transmit: "broadcast",
          url: "purchase_edit",
          request: {
            purchase_id: CurrentData_?.id,
            customer_name: ApplicationState?.CustomerName,
            mobile: ApplicationState?.Mobile,
            email: ApplicationState?.Email,
            use_case: ApplicationState?.UseCase?.value,
            age_group: ApplicationState?.AgeGroup?.value,
            pin_code_id: searchPincodeList?.pin?.id,
            district_id: searchPincodeList?.city?.id,
            state_id: searchPincodeList?.state?.id,
            frame_number: ApplicationState?.FrameNumber,
            product_id: ApplicationState?.ProductName?.value,
            product_name: ApplicationState?.ProductName?.label,
            franchise_id: ApplicationState?.DealerInfo?.value,
            franchise_name: ApplicationState?.DealerInfo?.label,
            invoice_image: Attachment?.fileID,
            invoice_image_name: Attachment?.filename,
            frame_available: shouldMarkFrameUnavailable
              ? false
              : ApplicationState?.FrameAvailable,
            product_value: ApplicationState?.ProductValue,
            is_voucher: VoucherFlag?.Yes,
            purchase_date: ApplicationState?.PurchaseDate,
          },
          DeviceId: device_id,
        };

        if (ApplicationState?.FrameNumberImage !== "") {
          param.request.frame_number_image = ApplicationState?.FrameNumberImage;
          param.request.frame_number_image_name = FrameImageDisplay?.name;
        }
        wsSend_request(websocket, param);
        seterrorAgeGroup("");
        seterrorUseCase("");
      } else {
        CheckValid(ApplicationState?.Mobile, {
          type: "phone",
          error: seterrorMobile,
        });
        CheckValid(ApplicationState?.Email.trim(), {
          type: "email",
          error: seterrorEmail,
        });
        CheckValid(ApplicationState?.PINCode.trim(), {
          type: "PINCode",
          error: seterrorPINCode,
        });
      }
    } else {
      CheckValid(ApplicationState?.CustomerName.trim(), {
        type: "Customername",
        error: seterrorCustomerName,
      });
      CheckValid(ApplicationState?.Email.trim(), {
        type: "email",
        error: seterrorEmail,
      });
      CheckValid(ApplicationState?.Mobile.trim(), {
        type: "phone",
        error: seterrorMobile,
      });
      CheckValid(ApplicationState?.PINCode.trim(), {
        type: "PINCode",
        error: seterrorPINCode,
      });
      CheckValid(ApplicationState?.DealerInfo, {
        type: "DealerInfo",
        error: seterrorDealerInfo,
      });
      CheckValid(ApplicationState?.ProductName, {
        type: "ProductName",
        error: seterrorProductName,
      });
      CheckValid(ApplicationState?.FrameNumber, {
        type: "FrameNumber",
        error: seterrorFrameNumber,
      });
      CheckValid(ApplicationState?.ProductValue.trim(), {
        type: "productValue",
        error: seterrorProductValue,
      });

      if (ApplicationState?.AgeGroup !== "") {
        seterrorAgeGroup("");
      } else {
        seterrorAgeGroup("Please select age groups");
      }
      if (ApplicationState?.UseCase !== "") {
        seterrorUseCase("");
      } else {
        seterrorUseCase("Please select User case");
      }

      if (Attachment?.fileID === null || Attachment?.fileID === "") {
        seterrorUploadFile(
          `Please upload ${VoucherFlag?.Yes ? "voucher" : "invoice"}`,
        );
      } else {
        seterrorUploadFile("");
      }
    }
  };

  // back clear data
  const clearDataAndRedux = () => {
    setTimeout(() => {
      Dispatch(SearchPincodeList({}));
      Dispatch(GetFrameList({}));
      Dispatch(
        ErrorMessageFromRedux({
          API: "",
          Error: "",
        }),
      );
      Dispatch(
        ErrorFramesMessageFromRedux({
          API: "",
          Error: "",
        }),
      );
    }, 500);
  };

  useEffect(() => {
    if (ClearFormSet?.action === 200 && ClearFormSet?.url === "purchase_edit") {
      Navigate(PURCHASE_LIST_URL);
      clearDataAndRedux();
      Dispatch(SearchPincodeList({}));
      Dispatch(GetFrameList({}));
      Dispatch(
        ErrorMessageFromRedux({
          API: "",
          Error: "",
        }),
      );
    }
  }, [ClearFormSet]);

  const [modalState, setModalState] = useState(false);
  const [error, setError] = useState();
  const [remarks, setRemarks] = useState("");
  const [promocodeEligigleState, setPromocodeEligibleState] = useState("");

  const [selectedRemark, setSelectedRemark] = useState("");
  const [otherRemark, setOtherRemark] = useState("");
  const onClose = () => {
    setModalState(false);
    setError("");
    setSelectedRemark("");
    setOtherRemark("");
  };

  const CancelWarranty = async (data) => {
    try {
      let payload = {
        purchase_id: CurrentData_?.id,
        remark: selectedRemark === "Other" ? otherRemark : selectedRemark,
        promo_eligible: promocodeEligigleState,
      };

      const response = await WarrantyCancellationAPI(accessToken, payload);
      if (response.status !== 200) {
        if (response.message) {
          toast.error(response.message);
        }
        if (response.error) {
          toast.error(response.error);
        }
      } else {
        toast.info(response.message);
        setModalState(false);
        Navigate(PURCHASE_LIST_URL);
      }
    } catch (error) {
      toast.error(
        "Error while marking promocode eligibility status",
        error.message,
      );
    }
  };

  let remarkOptions = [{ label: "Select Remark", value: "" }];
  const remarkOptionsData = AllHelpDeskSubcategoryList?.map((item) => ({
    label: item.sub_category_name,
    value: item.sub_category_name,
  }));
  remarkOptions = remarkOptions.concat(remarkOptionsData);

  const validateOtherRemark = (input) => {
    const text = input.trim();

    if (text.length < 50) {
      return "Please enter at least 50 characters.";
    }

    const words = text.split(/\s+/);
    if (words.length < 8) {
      return "Please enter a meaningful remark with enough detail.";
    }

    if (!/[a-zA-Z]/.test(text)) {
      return "Remark must contain meaningful text.";
    }

    if (/(.)\1{5,}/.test(text)) {
      return "Repeating characters are not allowed.";
    }

    if (/(asdf|qwerty|zxcv|1234)/i.test(text)) {
      return "Please avoid random text.";
    }

    return "";
  };

  const handleSelectChange = (e) => {
    const value = e.target.value;
    setSelectedRemark(value);
    setError("");

    if (value !== "Other") {
      setOtherRemark("");
    }
  };

  const handleOtherRemarkChange = (e) => {
    const value = e.target.value;
    setOtherRemark(value);

    if (value.trim()) {
      setError(validateOtherRemark(value));
    } else {
      setError("");
    }
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = () => {
    setIsSubmitting(true);
    if (!selectedRemark) {
      setError("Please select a remark.");
      return;
    }

    if (selectedRemark === "Other") {
      const validationError = validateOtherRemark(otherRemark);
      if (validationError) {
        setError(validationError);
        return;
      }

      CancelWarranty(otherRemark.trim());
      return;
    }

    CancelWarranty(selectedRemark);
  };

  const isSubmitDisabled =
    !selectedRemark ||
    (selectedRemark === "Other" && (!otherRemark.trim() || !!error));

  return (
    <section className="createApplcation_wrapper">
      <Modal show={modalState} onHide={onClose} className="commonModal">
        <Modal.Header className="border-bottom-0 bb-0 pb-0" closeButton>
          <Modal.Title className="h5">
            Remarks<span className="text-danger">*</span>
          </Modal.Title>
        </Modal.Header>

        <div className="formloginset p-3">
          <FormSelect value={selectedRemark} onChange={handleSelectChange}>
            {remarkOptions.map((option) => (
              <option
                key={option.value}
                value={option.value}
                disabled={option.value === ""}
              >
                {option.label}
              </option>
            ))}
          </FormSelect>

          {selectedRemark === "Other" && (
            <>
              <FormControl
                className="mt-3"
                placeholder="Enter remarks for promo eligibility"
                as="textarea"
                rows={4}
                onChange={handleOtherRemarkChange}
                value={otherRemark}
              />
              <small className="text-muted d-block mt-1">
                Minimum 50 characters required.
              </small>
            </>
          )}

          <small className="text-danger">{error}</small>
        </div>

        <div className="formloginset d-flex px-3 pb-3">
          <button
            id="formloginset"
            className="btn button-1 w-auto ms-auto"
            onClick={handleSubmit}
            disabled={isSubmitDisabled || isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </div>
      </Modal>
      <div className="MainHeader">
        <Link
          to={PURCHASE_LIST_URL}
          onClick={() => {
            clearDataAndRedux();
            Dispatch(SearchPincodeList({}));
            Dispatch(GetFrameList({}));
          }}
          className="btn btn-link backbtn"
        >
          <i className="bi bi-arrow-left-short"></i> Back
        </Link>
      </div>
      <div className="tabsWrappersmAN">
        <CommonScrollBar
          height={{ height: "calc(100vh - 135px)" }}
          className={"ScrollbarsSidebarHide"}
        >
          <div className="formloginset">
            <div className="row">
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Customer Name <span className="mendatory_star">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={ApplicationState?.CustomerName}
                    onChange={(e) =>
                      setApplicationState({
                        ...ApplicationState,
                        CustomerName: e.target.value,
                      })
                    }
                    onKeyUp={(e) =>
                      CheckValid(e.target.value, {
                        type: "Customername",
                        error: seterrorCustomerName,
                      })
                    }
                    onKeyDown={EmptySpaceFieldValid}
                    placeholder="Enter Customer Name"
                  />
                  {errorCustomerName !== "" && (
                    <span className="error_medotory">{errorCustomerName}</span>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Email ID <span className="mendatory_star">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={ApplicationState?.Email}
                    onChange={(e) =>
                      setApplicationState({
                        ...ApplicationState,
                        Email: e.target.value,
                      })
                    }
                    onKeyUp={(e) =>
                      CheckValid(e.target.value, {
                        type: "email",
                        error: seterrorEmail,
                      })
                    }
                    onKeyDown={EmptySpaceFieldValid}
                    placeholder="Enter Email ID"
                  />
                  {errorEmail !== "" && (
                    <span className="error_medotory">{errorEmail}</span>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Mobile Number <span className="mendatory_star">*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    className="inputBoxs"
                    value={ApplicationState?.Mobile}
                    onChange={(e) =>
                      setApplicationState({
                        ...ApplicationState,
                        Mobile: e.target.value.replace(/^0/, ""),
                      })
                    }
                    onKeyUp={(e) =>
                      CheckValid(e.target.value, {
                        type: "phone",
                        error: seterrorMobile,
                      })
                    }
                    onKeyDown={(e) => {
                      EmptySpaceFieldValid(e);
                      exceptThisCostSymbols.includes(e.key) &&
                        e.preventDefault();
                    }}
                    placeholder="Enter Mobile Number"
                  />
                  {errorMobile !== "" && (
                    <span className="error_medotory">{errorMobile}</span>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Use Case <span className="mendatory_star">*</span>
                  </Form.Label>
                  <div
                    className="selectMultiselect selectMultiselectBrand"
                    id="selectMultiselectBrand"
                  >
                    <Select
                      value={ApplicationState?.UseCase}
                      onChange={(e) => SelectUserCase(e)}
                      isClearable
                      options={optionsUseCase}
                      className="godown-select-container"
                      classNamePrefix="godown-select"
                      styles={customStyles}
                      placeholder="Select Use Case"
                      menuPlacement="auto"
                      menuPortalTarget={document.body}
                      filterOption={customFilterOption}
                    />
                  </div>
                  {errorUseCase !== "" && (
                    <span className="error_medotory">{errorUseCase}</span>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Age Group <span className="mendatory_star">*</span>
                  </Form.Label>
                  <div
                    className="selectMultiselect selectMultiselectBrand"
                    id="selectMultiselectBrand"
                  >
                    <Select
                      value={ApplicationState?.AgeGroup}
                      onChange={(e) => SelectAgeGroups(e)}
                      isClearable
                      options={optionsAgeGroups}
                      className="godown-select-container"
                      classNamePrefix="godown-select"
                      styles={customStyles}
                      placeholder="Select Age Group*"
                      menuPlacement="auto"
                      menuPortalTarget={document.body}
                      filterOption={customFilterOption}
                    />
                  </div>
                  {errorAgeGroup !== "" && (
                    <span className="error_medotory">{errorAgeGroup}</span>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>
                    PIN Code
                    <span className="mendatory_star">*</span>
                    <OverlayTrigger
                      placement="left"
                      delay={{ show: 250, hide: 100 }}
                      overlay={
                        <Tooltip
                          style={{ position: "fixed" }}
                          id="button-tooltip"
                          {...props}
                        >
                          Search by either hitting the enter button or clicking
                          on the search icon.
                        </Tooltip>
                      }
                    >
                      <small className="filedinfomsg">
                        <i className="bi bi-info-circle-fill"></i>
                      </small>
                    </OverlayTrigger>
                  </Form.Label>
                  <div className="serachBoxWIth">
                    <Form.Control
                      type="text"
                      value={ApplicationState?.PINCode}
                      onChange={(e) => PinCOdeSearchFunction(e)}
                      onKeyUp={(e) =>
                        CheckValid(e.target.value, {
                          type: "PINCode",
                          error: seterrorPINCode,
                        })
                      }
                      onKeyDown={(e) => {
                        EmptySpaceFieldValid(e);
                        onEnterPincodeSearch(e);
                      }}
                      disabled={commonLoader}
                      maxLength={6}
                      placeholder="Enter PIN Code"
                    />
                    <Button
                      className="searchbtn"
                      onClick={() => SearchPincode()}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="icon icon-tabler icon-tabler-search"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path
                          stroke="none"
                          d="M0 0h24v24H0z"
                          fill="none"
                        ></path>
                        <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
                        <path d="M21 21l-6 -6"></path>
                      </svg>
                    </Button>
                    {ErrorMessageFromReddux?.API === "pin_code_search" && (
                      <>
                        <div className="pincode_error">
                          {ErrorMessageFromReddux?.Error !== "" ? (
                            <i
                              className="bi bi-x-circle-fill"
                              onClick={() =>
                                setApplicationState({
                                  ...ApplicationState,
                                  PINCode: "",
                                })
                              }
                              style={{ color: "red" }}
                            ></i>
                          ) : (
                            <i
                              className="bi bi-check-circle-fill"
                              style={{ color: "#10b068" }}
                            ></i>
                          )}
                        </div>
                      </>
                    )}
                    {commonLoader && (
                      <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    )}
                  </div>
                  {errorPINCode !== "" && (
                    <span className="error_medotory">{errorPINCode}</span>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>City</Form.Label>
                  <div className="defaultvalueField">
                    {ErrorMessageFromReddux?.Error === ""
                      ? searchPincodeList?.city?.district_name
                      : ""}
                  </div>
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>State</Form.Label>
                  <div className="defaultvalueField">
                    {ErrorMessageFromReddux?.Error === ""
                      ? searchPincodeList?.state?.state_name
                      : ""}
                  </div>
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Product Value <span className="mendatory_star">*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    className="inputBoxs"
                    value={ApplicationState?.ProductValue}
                    onChange={(e) =>
                      setApplicationState({
                        ...ApplicationState,
                        ProductValue: e.target.value.replace(/^0/, ""),
                      })
                    }
                    onKeyUp={(e) =>
                      CheckValid(e.target.value, {
                        type: "productValue",
                        error: seterrorProductValue,
                      })
                    }
                    onKeyDown={(e) => {
                      EmptySpaceFieldValid(e);
                      exceptThisCostSymbols.includes(e.key) &&
                        e.preventDefault();
                    }}
                    placeholder="Enter Product Value"
                    min="0"
                  />
                  {errorProductValue !== "" && (
                    <span className="error_medotory">{errorProductValue}</span>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Frame Number
                    <span className="mendatory_star">*</span>
                    <OverlayTrigger
                      placement="left"
                      delay={{ show: 250, hide: 100 }}
                      overlay={
                        <Tooltip
                          style={{ position: "fixed" }}
                          id="button-tooltip"
                          {...props}
                        >
                          Search by either hitting the enter button or clicking
                          on the search icon.
                        </Tooltip>
                      }
                    >
                      <small className="filedinfomsg">
                        <i className="bi bi-info-circle-fill"></i>
                      </small>
                    </OverlayTrigger>
                  </Form.Label>
                  <div className="serachBoxWIth">
                    <Form.Control
                      type="text"
                      value={ApplicationState?.FrameNumber}
                      onChange={(e) => SearchInvoiceFunction(e)}
                      onKeyUp={(e) =>
                        CheckValid(e.target.value, {
                          type: "FrameNumber",
                          error: seterrorFrameNumber,
                        })
                      }
                      onKeyDown={(e) => {
                        EmptySpaceFieldValid(e);
                        onEnterInvoiceSearch(e);
                      }}
                      disabled={
                        commonMainLoader?.url === "get_frame_number" &&
                        commonMainLoader?.loader
                      }
                      placeholder="Search Frame Number"
                    />
                    <Button
                      className="searchbtn"
                      onClick={() => SearchOrderList()}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="icon icon-tabler icon-tabler-search"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path
                          stroke="none"
                          d="M0 0h24v24H0z"
                          fill="none"
                        ></path>
                        <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
                        <path d="M21 21l-6 -6"></path>
                      </svg>
                    </Button>
                    {ErrorFramesMessageFromReddux?.API ===
                      "get_frame_number" && (
                      <>
                        <div className="pincode_error">
                          {ErrorFramesMessageFromReddux?.Error !== "" ? (
                            <i
                              className="bi bi-x-circle-fill"
                              onClick={() =>
                                setApplicationState({
                                  ...ApplicationState,
                                  FrameNumber: "",
                                })
                              }
                              style={{ color: "red" }}
                            ></i>
                          ) : (
                            <i
                              className="bi bi-check-circle-fill"
                              style={{ color: "#10b068" }}
                            ></i>
                          )}
                        </div>
                      </>
                    )}
                    {commonMainLoader?.url === "get_frame_number" &&
                      commonMainLoader?.loader && (
                        <Spinner animation="border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </Spinner>
                      )}
                  </div>
                  {errorFrameNumber !== "" && (
                    <span className="error_medotory">{errorFrameNumber}</span>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Product Name <span className="mendatory_star">*</span>
                  </Form.Label>
                  <div
                    className="selectMultiselect selectMultiselectBrand"
                    id="selectMultiselectBrand"
                  >
                    <Select
                      onChange={(e) => ProductSelect(e)}
                      value={ApplicationState?.ProductName}
                      isClearable
                      options={optionsProduct}
                      className="godown-select-container"
                      classNamePrefix="godown-select"
                      placeholder="Select Products"
                      styles={customStyles}
                      menuPlacement="auto"
                      menuPortalTarget={document.body}
                      filterOption={customFilterOption}
                    />
                  </div>
                  {errorProductName !== "" && (
                    <span className="error_medotory">{errorProductName}</span>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Dealer Info <span className="mendatory_star">*</span>
                  </Form.Label>
                  <div
                    className="selectMultiselect selectMultiselectBrand"
                    id="selectMultiselectBrand"
                  >
                    <Select
                      value={ApplicationState?.DealerInfo}
                      onChange={(e) => FranchiseSelect(e)}
                      isClearable
                      options={FranchiseListOption}
                      className="godown-select-container"
                      classNamePrefix="godown-select"
                      placeholder="Select Franchise"
                      styles={customStyles}
                      menuPlacement="auto"
                      menuPortalTarget={document.body}
                      filterOption={customFilterOption}
                    />
                  </div>
                  {errorDealerInfo !== "" && (
                    <span className="error_medotory">{errorDealerInfo}</span>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3 ">
                  <Form.Label>Upload Frame Number Image</Form.Label>
                  {FrameImageDisplay !== undefined &&
                  FrameImageDisplay !== "" ? (
                    <div className="uplaodedFilename w-100">
                      <i className="bi bi-file-earmark-text"></i>
                      <span>{FrameImageDisplay?.name}</span>
                      <i
                        className="bi bi-x-circle-fill"
                        onClick={() => RemoveFrameNumberUploadImage()}
                      ></i>
                    </div>
                  ) : (
                    <label
                      id="UploadCmnBTN"
                      className="btn head_cmn_btn w-100 UploadCmnBTN UploadCmnAttchmentBTN"
                      style={{ width: "auto", marginTop: "0px", float: "left" }}
                    >
                      <i className="bi bi-upload"></i>
                      Upload Invoice
                      <input
                        type="file"
                        name={"Attachments"}
                        id="fileInputnew"
                        onChange={(e) => UploadFrameNumberImage(e)}
                        accept=".png, .jpg"
                      />
                      {UploadFrameNumberLoader && <Spinner />}
                    </label>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-4">
                <CommonToggle
                  isBadgeAllow={true}
                  badgeTitle={"yes_no"}
                  valueToggle={ApplicationState?.FrameAvailable}
                  setValueToggle={() =>
                    setApplicationState({
                      ...ApplicationState,
                      FrameAvailable: !ApplicationState?.FrameAvailable,
                    })
                  }
                  name={"Status"}
                />
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3 voucer_permission">
                  <Form.Label>Do You have a Voucher?</Form.Label>
                  <div className="custome_radio_button">
                    <label for="test1">
                      <input
                        type="radio"
                        id="test1"
                        name="radio-group"
                        checked={VoucherFlag?.Yes}
                        onChange={() => {
                          setVoucherFlag({
                            Yes: true,
                            No: false,
                          });
                        }}
                      />
                      Yes
                    </label>
                    <label for="test2">
                      <input
                        type="radio"
                        id="test2"
                        name="radio-group"
                        checked={VoucherFlag?.No}
                        onChange={() => {
                          setVoucherFlag({
                            Yes: false,
                            No: true,
                          });
                        }}
                      />
                      No
                    </label>
                  </div>
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3 ">
                  <Form.Label>
                    Upload {VoucherFlag?.Yes ? "Voucher" : "Invoice"}{" "}
                    <span className="mendatory_star">*</span>
                  </Form.Label>
                  {Attachment?.fileID === "" ? (
                    <label
                      id="UploadCmnBTN"
                      className="btn head_cmn_btn w-100 UploadCmnBTN UploadCmnAttchmentBTN"
                      style={{ width: "auto", marginTop: "0px", float: "left" }}
                    >
                      <i className="bi bi-upload"></i>
                      <input
                        type="file"
                        name={"Attachments"}
                        id="fileInput"
                        onChange={(e) => UploadImage(e)}
                        accept=".png, .jpg, .pdf"
                      />
                      Upload Invoice
                      {LoaderFile && <Spinner />}
                    </label>
                  ) : (
                    <div className="uplaodedFilename w-100">
                      <i className="bi bi-file-earmark-text"></i>
                      {Attachment?.filename}
                      <i
                        className="bi bi-x-circle-fill"
                        onClick={() => {
                          setAttachment({
                            ...Attachment,
                            filename: "",
                            fileID: "",
                          });
                        }}
                      ></i>
                    </div>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Purchase Date <span className="mendatory_star">*</span>
                  </Form.Label>
                  <div className="datepickField min">
                    <DatePicker
                      selected={ApplicationState?.PurchaseDate}
                      onChange={(date) =>
                        setApplicationState({
                          ...ApplicationState,
                          PurchaseDate: date,
                        })
                      }
                      dateFormat="yyyy-MM-dd"
                      onKeyUp={(e) =>
                        CheckValid(e.target.value, {
                          type: "PurchaseDate",
                          error: seterrorPurchaseDate,
                        })
                      }
                      autoComplete="off"
                    />
                  </div>
                  {errorPurchaseDate !== "" && (
                    <span className="error_medotory">{errorPurchaseDate}</span>
                  )}
                </Form.Group>
              </div>
            </div>
          </div>
          <div className="row">
            <div
              className="d-flex justify-content-end w-100"
              style={{ gap: "1em" }}
            >
              {
                <Button
                  className="formbtndanger widthfullbtn rounded-2"
                  style={{ float: "right", width: "auto" }}
                  onClick={() => {
                    setModalState(true);
                  }}
                  variant="primary"
                >
                  Cancel Warranty
                </Button>
              }
              <Button
                className="formbtn widthfullbtn"
                style={{ float: "right", width: "auto" }}
                onClick={() => SubmitFunction()}
                variant="primary"
              >
                Update
              </Button>
            </div>
          </div>
        </CommonScrollBar>
      </div>
    </section>
  );
};

export default EditPurchase;
